import { truckerProfileApiService } from 'config/service';
import { urls } from 'constants/urls';

export const removeContact = (personUuid: string) =>
  truckerProfileApiService.delete(`${urls.contactList.contact}/${personUuid}`);
